module.exports = __webpack_public_path__ + "img/restaurants-features-overview.7942636e.png";